import React, { Component, useEffect, useRef } from 'react';
import RoutingService from './services/routingService';
import HomePage from './Pages/Home/HomePage';
import { Routes, Route } from 'react-router';
import { BrowserRouter, useLocation } from 'react-router-dom';
import PasswordChangePage from './Pages/PasswordChange/PasswordChangePage';
import ForCompaniesPage from './Pages/ForCompanies/ForCompaniesPage';
import TermsPage from './Pages/Terms/TermsPage';
import LogInPage from './Pages/LogIn/LogInPage';
import SignUpPage from './Pages/SignUp/SingUpPage';
import StatusPage from './Pages/Account/Status/StatusPage';
import Layout from './Pages/Layout/Layout';
import CookieConsent, { getCookieConsentValue } from "react-cookie-consent";
import NewsletterPage from './Pages/Newsletter/NewsletterPage';

const GA_TRACKING_ID = 'G-T2E73S1654';

function loadGoogleAnalytics() {
    if (document.getElementById('ga-script')) return;
    (window as any).dataLayer = (window as any).dataLayer || [];
    function gtag(...args: any[]) { (window as any).dataLayer.push(args); }
    (window as any).gtag = gtag;
    gtag('consent', 'default', {
        analytics_storage: 'denied',
    });
    gtag('js', new Date());
    gtag('config', GA_TRACKING_ID);

    const script = document.createElement('script');
    script.id = 'ga-script';
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_TRACKING_ID}`;
    document.head.appendChild(script);
}

function grantAnalyticsConsent() {
    if (typeof (window as any).gtag === 'function') {
        (window as any).gtag('consent', 'update', { analytics_storage: 'granted' });
    }
}

function AnalyticsPageViewTracker() {
    const location = useLocation();
    const isFirstRender = useRef(true);

    useEffect(() => {
        if (isFirstRender.current) {
            isFirstRender.current = false;
            return;
        }
        if (typeof (window as any).gtag === 'function') {
            (window as any).gtag('event', 'page_view', {
                page_path: location.pathname + location.search,
            });
        }
    }, [location]);

    return null;
}

type AppProps = {
};

type AppState = {
};

class App extends Component<AppProps, AppState> {
    constructor(props: AppProps) {
        super(props);

        this.state = {
        };
    }

    componentDidMount() {
        loadGoogleAnalytics();
        if (getCookieConsentValue('mediti-cookie-consent') === 'true') {
            grantAnalyticsConsent();
        }
    }

    public render() {
        return (
            <div className="App">
                <BrowserRouter>
                    <AnalyticsPageViewTracker />
                    <Routes>
                        <Route element={<Layout />}>
                            <Route path={RoutingService.getMainPageRoute()} element={<HomePage />} />
                            <Route path={RoutingService.getPasswordChangePageRoute()} element={<PasswordChangePage />} />
                            <Route path={RoutingService.getForCompaniesPageRoute()} element={<ForCompaniesPage />} />
                            <Route path={RoutingService.getTermsPageRoute()} element={<TermsPage />} />
                            <Route path={RoutingService.getLogInPageRoute()} element={<LogInPage />} />
                            <Route path={RoutingService.getSignUpPageRoute()} element={<SignUpPage />} />
                            <Route path={RoutingService.getUserAccountStatusPageRoute()} element={<StatusPage />} />
                        </Route>
                        <Route path={RoutingService.getNewsletterLandingPageRoute()} element={<NewsletterPage />} />
                    </Routes>
                </BrowserRouter>

                <CookieConsent
                    location="bottom"
                    buttonText="Akceptuję"
                    enableDeclineButton
                    declineButtonText="Odrzucam"
                    cookieName="mediti-cookie-consent"
                    style={{ background: "#2B373B", fontSize: "15px" }}
                    buttonStyle={{ color: "#4e503b", fontSize: "13px", borderRadius: "5px" }}
                    declineButtonStyle={{ fontSize: "13px", borderRadius: "5px" }}
                    expires={150}
                    onAccept={grantAnalyticsConsent}
                >
                    Ta strona korzysta z ciasteczek analitycznych (Google Analytics).{" "}
                    <a href={RoutingService.getTermsPageRoute()} style={{ color: "#fff", textDecoration: "underline" }}>
                        Polityka prywatności
                    </a>
                </CookieConsent>
            </div>


        );
    }
}

export default App;
